// extracted by mini-css-extract-plugin
export default {"container":"ModalPreviewProduct_container__6EdgA"};